import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { ToolCallCardProps } from '../types';

const ToolCallCard = ({ toolCall }: ToolCallCardProps) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const { name, args, result, ok } = toolCall;

  return (
    <div className={`tool-call-card ${ok === null ? 'pending' : ok ? 'success' : 'failure'}`}>
      <button className="tool-call-header" onClick={() => setExpanded((value) => !value)} type="button">
        <span className="tool-call-icon">
          {ok === null ? (
            <span className="spinner-border spinner-border-sm" />
          ) : ok ? (
            <i className="ti ti-check text-success" />
          ) : (
            <i className="ti ti-x text-danger" />
          )}
        </span>
        <span className="tool-call-name">
          {t('assistant.toolCalling')}: <code>{name}</code>
        </span>
        <i className={`ti ms-auto ${expanded ? 'ti-chevron-up' : 'ti-chevron-down'}`} />
      </button>

      {expanded && (
        <div className="tool-call-details">
          <div className="tool-call-section">
            <span className="text-muted small">{t('assistant.toolArgs')}</span>
            <pre>{JSON.stringify(args, null, 2)}</pre>
          </div>
          {result !== null && result !== undefined && (
            <div className="tool-call-section">
              <span className="text-muted small">{t('assistant.toolResult')}</span>
              <pre>{JSON.stringify(result, null, 2)}</pre>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ToolCallCard;
